import { Injectable } from '@angular/core';
import { UnsettledPaymentsCollectionQuery, UnsettledPaymentsCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UnsettledPaymentsCollectionQuery)
@Wrapper(UnsettledPaymentsCollectionQueryHandlerBase)
export class UnsettledPaymentsCollectionQueryHandler {
    public constructor(
        rootContext: RootContext,
        http: Http
    ) { }
}
